import React from "react";
import { IntlProvider } from "react-intl";
import { ThemeProvider } from "styled-components";

import { GlobalCSS, ResetCSS, Themes } from "mf-ui-components";

import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { ServiceUnavailable } from "./components/ServiceUnavailable";
import { getMessagesByLocale } from "./lang/messages";

const locale = navigator.language;

export const App = () => (
  <>
    <ResetCSS />
    <GlobalCSS />
    <ThemeProvider theme={Themes.mf}>
      <IntlProvider
        defaultLocale="en"
        locale={locale}
        messages={getMessagesByLocale(locale)}
      >
        <Header />
        <ServiceUnavailable />
        <Footer />
      </IntlProvider>
    </ThemeProvider>
  </>
);
